var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageColorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.37,
    height: 22.76,
    viewBox: "0 0 17.37 22.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IMAGE",
    transform: "translate(-2.13 -0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2129",
    "data-name": "Path 2129",
    d: "M19.49,22.08a.681.681,0,0,1-.67.69H2.8a.681.681,0,0,1-.67-.69V.7A.687.687,0,0,1,2.8.01H14.61c.87.93,4.51,4.47,4.88,4.94V22.07Z",
    fill: "#e0f4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2130",
    "data-name": "Path 2130",
    d: "M19.49,15.86H2.14v6.2a.681.681,0,0,0,.67.69H18.83a.681.681,0,0,0,.67-.69V15.87Z",
    fill: "#4e66cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2131",
    "data-name": "Path 2131",
    d: "M14.65.02V4.31a.628.628,0,0,0,.62.61h4.18Z",
    fill: "#99badb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2132",
    "data-name": "Path 2132",
    d: "M12.91,6.44H7.07a.516.516,0,0,0-.52.52V12.8a.516.516,0,0,0,.52.52h5.84a.516.516,0,0,0,.52-.52V6.96a.516.516,0,0,0-.52-.52Zm-5.89.52s.02-.05.05-.05h5.84s.05.02.05.05v3.69L11.6,8.82,9.74,11.38l-1.18-.96L7.01,11.87V6.95Z",
    fill: "#adadad"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_212",
    "data-name": "Ellipse 212",
    cx: 0.45,
    cy: 0.45,
    r: 0.45,
    transform: "translate(7.84 7.7)",
    fill: "#adadad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2133",
    "data-name": "Path 2133",
    d: "M4.48,20.76H3.94V17.65h.54Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2134",
    "data-name": "Path 2134",
    d: "M5.84,17.66l.9,2.38.89-2.38h.7v3.11H7.79V19.75l.05-1.37-.92,2.39H6.53l-.92-2.39.05,1.37v1.02H5.12V17.66h.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2135",
    "data-name": "Path 2135",
    d: "M10.74,20.04H9.54l-.25.72H8.73L9.9,17.65h.48l1.18,3.11H11l-.25-.72ZM9.69,19.6h.9l-.45-1.29L9.69,19.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2136",
    "data-name": "Path 2136",
    d: "M14.25,20.36a1.689,1.689,0,0,1-.14.14,1.4,1.4,0,0,1-.22.15,1.276,1.276,0,0,1-.33.11,2,2,0,0,1-.45.05,1.4,1.4,0,0,1-.54-.1,1.192,1.192,0,0,1-.69-.76,2.08,2.08,0,0,1-.1-.63v-.2a1.994,1.994,0,0,1,.09-.63,1.318,1.318,0,0,1,.25-.47.962.962,0,0,1,.4-.29,1.333,1.333,0,0,1,.54-.1,1.448,1.448,0,0,1,.49.07,1.068,1.068,0,0,1,.36.21.937.937,0,0,1,.23.32,1.24,1.24,0,0,1,.11.4h-.53a.709.709,0,0,0-.06-.22.567.567,0,0,0-.12-.18.615.615,0,0,0-.19-.12.766.766,0,0,0-.27-.04.671.671,0,0,0-.33.07.659.659,0,0,0-.23.21,1,1,0,0,0-.14.33,2,2,0,0,0-.05.45v.21a1.532,1.532,0,0,0,.06.45,1.015,1.015,0,0,0,.16.33.6.6,0,0,0,.25.2.739.739,0,0,0,.34.07.9.9,0,0,0,.24-.02.687.687,0,0,0,.17-.05.542.542,0,0,0,.11-.06.435.435,0,0,0,.07-.06v-.61h-.64v-.41h1.18v1.19Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2137",
    "data-name": "Path 2137",
    d: "M16.65,19.38H15.38v.96h1.49v.43H14.84V17.66h2.02v.44H15.38v.86h1.27v.43Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageColorIcon);
export default __webpack_public_path__ + "static/media/image-color-icon.62335bc93aaed27d5e60b96e18c4e7e1.svg";
export { ForwardRef as ReactComponent };